import InstitutionSignUpForm from 'components/modules/auth/InstitutionSignUpForm/InstitutionSignUpForm';
import AuthCardLayout from 'layouts/AuthCardLayout';

function InstitutionSignUp() {
  return (
    <AuthCardLayout className="card-sign-up">
      <InstitutionSignUpForm />
    </AuthCardLayout>
  );
}

export default InstitutionSignUp;
